import { changeType } from "../helpers/ResultsHelpers";
import ProgressBar from "@ramonak/react-progress-bar";

type EvalGraphsResultsProps = {
  typeEval?: any;
  pct?: any;
  evaluation?: any;
  evalTxt?:any;
};

const EvalGraphsResults = ({ typeEval, pct, evaluation,evalTxt }: EvalGraphsResultsProps) => {
  return (
    Number(pct) > 0 ? (
      <div className="infoEvalGraph">
        <div >
          <span className="txtNameEvalModel">{changeType(typeEval)}</span>
        </div>
        <div className="containerProrgesBarEvalModel">
          <ProgressBar
            completed={evaluation} 
            customLabel=" "
            labelSize="12px"
            bgColor="#3BCBB0"
            width="100%"
            height="15px"
          />
        </div>
        <div className="containerCalfInfoResModelEvalFinGraph">
          <span className="calfInfoResModelEvalFinGraph">{evaluation}</span>
        </div>
        {/* <div className="containerCalfInfoResModelEvalFinGraphTxt">
          <span className="calfInfoResModelEvalFinGraph">{evalTxt}</span>
        </div> */}
      </div>
    ) : null
  );
};

export default EvalGraphsResults;
